import React from 'react'
import Hero from '../heropart/Hero';
import Service from '../services/Service';
import Contact from '../contact/Contact';
const Home = () => {
    
    return (
        <main>
            <Hero/>
            <Service/>
            <Contact/>
        </main>
    );
}

export default Home